module.exports = __webpack_public_path__ + "img/9788974834197.e5695227.jpg";